export default __webpack_public_path__ + "static/media/pgmico(37).73dda7a5.png";